import * as React from 'react';
import clsx from 'clsx';

interface AuthPromoBlockProps {
  heading: string;
  features: string[];
  cta: string;
  compact?: boolean;
}

/** UTM promo section with heading, feature list, and CTA. */
export const AuthPromoBlock: React.FC<AuthPromoBlockProps> = ({
  heading,
  features,
  cta,
  compact = false,
}) => (
  <div className={clsx(compact ? 'mb-0' : 'mb-6', 'flex flex-col items-start')}>
    <h2
      className={clsx(
        'text-left font-proxima font-bold tracking-normal',
        compact
          ? 'text-30 leading-[36px] text-white fold:text-30 fold:text-brand-800'
          : 'text-20 leading-25 text-white fold:text-30 fold:text-brand-800'
      )}
    >
      {heading}
    </h2>

    <ul className='mt-4 flex flex-col gap-2'>
      {features.map((text) => (
        <li
          key={text}
          className={clsx(
            'flex items-start gap-2 font-sans font-normal tracking-normal',
            compact
              ? 'text-14 leading-20 text-white fold:text-brand-750'
              : 'text-12 leading-18 text-white fold:text-brand-750'
          )}
        >
          <span className='shrink-0'>&#10004;</span>
          <span>{text}</span>
        </li>
      ))}
    </ul>

    {!compact && (
      <p className='mt-4 font-sans text-15 font-bold leading-18 tracking-normal text-white fold:text-brand-750'>
        {cta}
      </p>
    )}
  </div>
);
